import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var SpannerIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18629 5.09604C3.06571 5.43117 3 5.79248 3 6.16914C3 7.9194 4.41887 9.33827 6.16914 9.33827C6.50074 9.33827 6.82045 9.28734 7.12087 9.19288L11.2279 13.7912C11.9226 14.569 13.1282 14.603 13.8656 13.8656C14.603 13.1282 14.5691 11.9226 13.7913 11.2279L9.19288 7.12085C9.28734 6.82044 9.33827 6.50073 9.33827 6.16914C9.33827 4.41887 7.9194 3 6.16914 3C5.7924 3 5.43103 3.06574 5.09584 3.18636C5.12879 3.21193 5.16051 3.23985 5.19077 3.27011L6.47701 4.55635C6.86753 4.94687 6.86753 5.58004 6.47701 5.97056L5.97044 6.47713C5.57991 6.86766 4.94675 6.86766 4.55622 6.47714L3.26998 5.19089C3.23974 5.16065 3.21185 5.12896 3.18629 5.09604ZM12.4054 13.3604C12.9055 13.3604 13.3109 12.955 13.3109 12.4549C13.3109 11.9548 12.9055 11.5494 12.4054 11.5494C11.9054 11.5494 11.5 11.9548 11.5 12.4549C11.5 12.955 11.9054 13.3604 12.4054 13.3604Z"
  }));
});
SpannerIcon.displayName = 'SpannerIcon';
export default SpannerIcon;